<template>
  <sh-page theme="light">
    <div id="mapContainer">
      <div id="map"></div>
      <sh-spinner
        style="position: absolute"
        overlay="true"
        v-if="loadingGlobalMapData"
        label="Loading Countries Map"
      ></sh-spinner>
    </div>
  </sh-page>
  <!-- <div>this is the global map</div> -->
</template>

<script>
import mapboxgl from "mapbox-gl";
import { mapGetters, mapMutations, mapActions } from "vuex";
import router from "../router";

export default {
  name: "GlobalMap",
  data() {
    return {
      map: null,
      loadingGlobalMapData: false,
    };
  },
  computed: {
    ...mapGetters(["accessToken", "countries"]),
  },
  mounted() {
    console.log(
      "___________________________GlobalMap Mounted___________________________"
    );
    this.setSelectedCountry({});
    this.getGlobalMapData();
  },
  destroyed() {
    console.log("GlobalMap destroyed!");
  },
  beforeUnmount() {
    if (this.map) {
      this.map.remove();
    }
  },
  methods: {
    ...mapActions(["loadCountries"]),
    ...mapMutations(["setSelectedCountry"]),

    async getGlobalMapData() {
      this.loadingGlobalMapData = true;
      await this.loadCountries();

      this.initMap();

      this.map.once("idle", () => {
        this.map.resize();
        this.loadingGlobalMapData = false;

        var valueFromCookie = this.getCookie("isNew");
        if (valueFromCookie === null) {
          document.querySelector("#change-modal").visible = true;
          this.setCookie("isNew", "3 hours", 1 / 8);
        }
      });
    },
    initMap() {
      mapboxgl.accessToken = this.accessToken;

      this.map = new mapboxgl.Map({
        container: "map",
        style: "mapbox://styles/mapbox/light-v10",
        // center: [-98, 38.88],
        center: [1, 20],
        minZoom: 1,
        maxZoom: 10,
        zoom: 1.5,
      });

      this.map.addControl(new mapboxgl.ScaleControl());
      this.map.on("load", () => {
        this.map.getCanvas().style.cursor = "default";

        this.map.addSource("country-boundaries", {
          type: "vector",
          url: "mapbox://mapbox.country-boundaries-v1",
        });

        const layers = this.map.getStyle().layers;
        // Find the index of the first symbol layer in the map style.
        let firstSymbolId;
        for (const layer of layers) {
          if (layer.type === "symbol") {
            firstSymbolId = layer.id;
            break;
          }
        }

        this.countries.forEach((country) => {
          this.map.addLayer(
            {
              id: country.iso_3166_1,
              type: "fill",
              source: "country-boundaries",
              "source-layer": "country_boundaries",
              paint: {
                "fill-color": [
                  "match",
                  ["get", "name"],
                  country.name,
                  country.color,
                  "transparent",
                ],
                "fill-outline-color": "transparent",
                "fill-opacity": 1,
              },
              filter: ["==", "iso_3166_1", country.iso_3166_1],
            },
            firstSymbolId
          ); // Place polygon under these labels.
        });

        this.map.addLayer(
          {
            id: "countries-highlighted",
            type: "fill",
            source: "country-boundaries",
            "source-layer": "country_boundaries",
            paint: {
              "fill-color": "#2f5c62",
              "fill-opacity": 1,
            },
            filter: ["==", "iso_3166_1", ""],
          },
          firstSymbolId
        );

        const countryName_popup = new mapboxgl.Popup({
          closeButton: false,
          closeOnClick: false,
        });

        this.countries.forEach((country) => {
          this.map.on("mousemove", country.iso_3166_1, (e) => {
            this.map.getCanvas().style.cursor = "pointer";

            this.map.setFilter("countries-highlighted", [
              "==",
              "iso_3166_1",
              country.iso_3166_1,
            ]);

            countryName_popup
              .setLngLat(e.lngLat)
              .setHTML(country.name)
              .addTo(this.map);
          });

          this.map.on("mouseleave", country.iso_3166_1, () => {
            this.map.getCanvas().style.cursor = "default";
            this.map.setFilter("countries-highlighted", [
              "==",
              "iso_3166_1",
              "",
            ]);
            countryName_popup.remove();
          });

          this.map.on("click", country.iso_3166_1, () => {
            console.log(country.iso_3166_1);

            this.setSelectedCountry(country);

            router.push({
              name: "CountyMap",
              params: {
                country: country.iso_3166_1,
              },
              // props: { },
            });
          });
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
#map {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  border-radius: 0.25rem;
  border: 1px solid #ccc;
}

.mapboxgl-map {
  font-family: "siemens sans", sans-serif;
}

.mapboxgl-popup-content {
  text-align: center;
  font-family: "siemens sans", sans-serif;
}
</style>
